/**
 * Format email body text for HTML display in Office.js
 * Handles multiple newline formats and preserves formatting
 * @param body - Plain text or HTML body content
 * @returns HTML-formatted body suitable for Office.js APIs
 */
export const formatEmailBody = (body) => {
    // Replace various newline formats with <br> tags
    // Handle Windows (\r\n), Unix (\n), and Mac (\r) line endings
    return body
        .replace(/\r\n/g, '<br>') // Windows line endings first
        .replace(/\n/g, '<br>') // Unix line endings
        .replace(/\r/g, '<br>'); // Classic Mac line endings
};
